module.exports = __webpack_public_path__ + "static/img/cover8.362936a2.jpg";